module.exports = __webpack_public_path__ + "static/media/brand-no-r.0a71b21c.png";